import { Component, OnInit, Inject, NgZone } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { Loader } from '@googlemaps/js-api-loader';
import { ConstantsService } from '../services/constants.service';
import allVideos from '../videos/allVideos.json';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';

@Component({
  selector: 'app-map-search',
  templateUrl: './map-search.component.html',
  styleUrls: ['./map-search.component.scss'],
})
export class MapSearchComponent implements OnInit {

  videos = allVideos.allVideos;
  mapsearchcontainer: boolean = false;
  tagcontainers: boolean = true;
  private map;
  markers: any;
  lat: number;
  lng: number;
  marker: any;
  service: google.maps.places.PlacesService;
  public Placesng: string = '';
  CountryList: any = [];
  showSearchIcon: boolean = true;
  loader: any;
  tag = '';
  selectedCountry: string;
  placeName = '';
  cluster: any;
  isEmptyResult = false
  isNoResult = false;
  filtername: any;
  public isPrime: any;
  checkprime: boolean = false;
  userName: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public constants: ConstantsService,
    public dialogRef: MatDialogRef<MapSearchComponent>,
    public router: Router,
    private mixpanel: SharedMixpanelService
  ) { }

  ngOnInit(): void {
    this.isPrime = this.data.prime;
    this.userName = this.data.userName;
    if (this.isPrime) {
      this.loader = new Loader({
        apiKey: environment.GMAP_API_KEY,
        libraries: ['places'],
      });
      this.loader.load().then(() => {
        this.initMap();
      });
    }
  }
  initMap() {
    let mapCentre = { lat: 54.525961, lng: 15.255119 };
    let showBoolean = false
    if (this.data.videoItem) {
      showBoolean = true;
      mapCentre.lat = this.data.videoItem.Latitude;
      mapCentre.lng = this.data.videoItem.Longitude;
    }
    this.map = new google.maps.Map(
      document.getElementById('maps') as HTMLElement,
      {
        center: showBoolean ? mapCentre : this.constants.DEFAULT_MAP_CENTRE,
        zoom: showBoolean ? 8 : 3,
        mapId: environment.GOOGLE_MAP_ID,
        mapTypeControl: false,
        maxZoom: 8,
        minZoom: 2,
        disableDefaultUI: true,
      }
    );
    // filter video on map grag and zoom
    this.map.addListener("bounds_changed", () => {
      let bounds = this.map.getBounds().toJSON();
      if (this.cluster !== undefined) {
        this.cluster.clearMarkers();
      }
      let north = bounds.north;
      let west = bounds.west;
      let east = bounds.east;
      let south = bounds.south;
      let updatedVideoList = this.videos.filter(video => {
        let latitude = parseFloat(video.Latitude);
        let longitude = parseFloat(video.Longitude);
        return latitude > south && latitude < north && longitude > west && longitude < east;
      })
      if (updatedVideoList.length === 0 && this.map.getZoom() < 5) {
        this.mapInIt(this.videos);
      }
      else {
        updatedVideoList.length === 0 ? this.mapInIt(this.videos) : this.mapInIt(updatedVideoList);
      }

    });
  }
  mapInIt(videos) {
    const input = document.getElementById("pac-input") as HTMLInputElement;
    const searchBox = new google.maps.places.SearchBox(input);
    const image = {
      url: this.constants.MAP_MARKER_IMG,
      size: new google.maps.Size(30, 40),
    };
    this.markers = videos.map(video => {
      const myLatlng = new google.maps.LatLng(
        video.Latitude as number,
        video.Longitude as number
      );
      let marker = new google.maps.Marker({
        position: myLatlng,
        icon: image,
      });
      marker.addListener("click", () => {
        this.isPrime ? this.checkprime = false : this.checkprime = true;
        if (this.isPrime === true) {
          let country = video['cityLocation']
          let videos = [video];
          let result = {
            isWindowClose: false,
            videos: videos,
            country: country,
            windowHeader: true,
          }
          this.dialogRef.close(result);
          this.mixpanel.actions.track('Map Pin Click', {
            Email: this.userName,
            videos: videos,
            Location: country
          });
        }
      });
      return marker;
    });
    this.setCluster(this.markers, this.map, videos);
    this.search(searchBox);

  }
  setCluster(markers, map, videos) {
    const renderer = {
      render: ({ count, position }) =>
        new google.maps.Marker({
          label: { text: String(count), color: 'white', fontSize: '12px' },
          position,
          icon: this.constants.MAP_CLUSTER_IMG,
        }),
    };
    this.cluster = new MarkerClusterer({ map, markers, renderer });
    this.cluster.addListener("click", (event) => {
      if (this.map.getZoom() === 8) {
        let markers = event.markers
        this.openWindowOnClickMarker(videos, markers)
      }
    })
  }
  openWindowOnClickMarker(videos, markers): any {
    let distanceArray = [];
    let lat = this.map.getCenter().lat();
    let lng = this.map.getCenter().lng();
    videos.map(video => {
      let lat1 = video.Latitude as number;
      let lng1 = video.Longitude as number;
      let distance = this.calcCrow(lat, lng, lat1, lng1);
      distanceArray.push(distance);
    })

    let min = Math.min(...distanceArray);
    let index = distanceArray.indexOf(min);
    this.selectedCountry = videos[index].cityLocation.split(' - ')[1];
    videos = this.sortVideoBasedOnClusterClicked(markers, videos)
    
    let result = {
      isWindowClose: false,
      videos: videos,
      country: this.selectedCountry,
      windowHeader: true,
    }
    this.mixpanel.actions.track('Map Cluster Click', {
      Email: this.userName,
      videos: videos,
      Location: this.selectedCountry
    });
    this.dialogRef.close(result);
  }
  sortVideoBasedOnClusterClicked(markers, videos) {
    let newVideoArray = [];
    var count = 0;
    let uniqueMarkers = [];
    let latlngAray = [];
    let temp = {};
    markers.forEach((marker) => {
      latlngAray.push(marker.getPosition().toJSON())
      if (temp['lat'] !== marker.getPosition().lat()) {
        temp = marker.getPosition().toJSON();
        uniqueMarkers.push(marker.getPosition().toJSON())

      }
    })
    
    uniqueMarkers.forEach((marker) => {
      let filteredVideos = [];
      filteredVideos = videos.filter(video => video.Latitude === marker.lat && video.Longitude === marker.lng);
      newVideoArray = [...newVideoArray, ...filteredVideos];
    })
    return newVideoArray;
  }
  calcCrow(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = this.toRad(lat2 - lat1);
    var dLon = this.toRad(lon2 - lon1);
    var lat1: any = this.toRad(lat1);
    var lat2: any = this.toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }

  // Converts numeric degrees to radians
  toRad(Value) {
    return Value * Math.PI / 180;
  }
  search(searchBox) {
    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();
      this.onSearch(places);
      if (places.length == 0) {
        return;
      }
      // For each place, get the icon, name and location.
      const bounds = new google.maps.LatLngBounds();
      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          return;
        }
        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      this.map.fitBounds(bounds);
    });
  }

  //map search
  Close() {
    this.showSearchIcon = true;
    this.Placesng = '';
    this.placeName = '';
    this.videos = allVideos.allVideos;
    this.cluster.clearMarkers();
    this.map.setZoom(3);
    this.mapInIt(this.videos);
    this.mapsearchcontainer = false;
    this.isEmptyResult = false;
    this.isNoResult = false;
  }
  onSearch(places) {
    this.selectedCountry = places[0].formatted_address;
    this.mixpanel.actions.track('Map Search', {
      Email: this.userName,
      Searched_Location: this.selectedCountry
    });
    this.showSearchIcon = false;
    this.videos = allVideos.allVideos;
    let searchingName = places[0].name;
    this.mapsearchcontainer = true;
    let filteredVideos;
    let filteredByCountry;
    this.placeName = this.constants.OPEN_WINDOW_IN + searchingName;
    let filter_data = {
      country: '',
      locality: '',
      administrative_area_level_1: ''
    };
    if (places.length > 0 && places[0].address_components) {
      for (let element of places[0].address_components) {
        filter_data[element.types[0]] = element.long_name;
      }
    }

    if (filter_data.locality === '' && filter_data.administrative_area_level_1 === '' && filter_data.country === '') {
      filteredVideos = this.videos.filter(video => video.cityLocation.toUpperCase().includes(searchingName.toUpperCase()));
      if (filteredVideos.length === 0) {
        this.isEmptyResult = true;
        this.mapsearchcontainer = false;
      }
    }
    else if (filter_data.locality === '' && filter_data.administrative_area_level_1 === '' && filter_data.country != '') {
      filteredVideos = this.filterOnCountry(searchingName, this.videos);
      if (filteredVideos.length === 0) {
        this.isEmptyResult = true;
        this.mapsearchcontainer = false;
      }
    }
    else {
      filteredByCountry = this.filterOnCountry(filter_data.country, this.videos);
      if (filteredByCountry.length === 0) {
        this.isEmptyResult = true;
        this.isNoResult = false;
        this.mapsearchcontainer = false;
      }
      else {
        filteredVideos = this.filterOnLocality(searchingName, filteredByCountry)
        if (filteredVideos.length === 0) {
          this.isNoResult = true;
          if (filter_data.locality != '') {
            filteredVideos = this.filterOnLocality(filter_data.locality, filteredByCountry);
            if (filteredVideos.length === 0) {
              filteredVideos = this.filterOnAdmistrativeAreaLevel1(filter_data.administrative_area_level_1, filteredByCountry);
            }
          }
          else {
            filteredVideos = this.filterOnAdmistrativeAreaLevel1(filter_data.administrative_area_level_1, filteredByCountry);
          }
        }
      }
    }
    this.videos = filteredVideos;
  }
  filterOnCountry(country, videos) {
    country = country.toUpperCase();
    if (country == this.constants.COUNTRY_USA || country == this.constants.COUNTRY_USA_1 || country == this.constants.COUNTRY_USA_2) {
      country = this.constants.COUNTRY_USA;
    }
    else if (country == this.constants.COUNTRY_UK || country == this.constants.COUNTRY_UK_1) {
      country = this.constants.COUNTRY_UK;
    }
    else if (country == this.constants.COUNTRY_UAE || country == this.constants.COUNTRY_UAE_1) {
      country = this.constants.COUNTRY_UAE;
    }
    let filteredVideos = videos.filter((video: { cityLocation: string }) => {
      if (video.cityLocation) {
        let cityParts = video.cityLocation.split(' - ');
        if (cityParts.length > 1) {
          return cityParts[1].toUpperCase().includes(country.toUpperCase());
        }
      }
      return false;
    });

    return filteredVideos;
  }
  filterOnLocality(localityOrState, filteredVideos) {
    let videoFiltered = filteredVideos.filter(video => {
      return (video.cityLocation.split(' - ')[0].toUpperCase()).includes(localityOrState.toUpperCase())
    });
    return videoFiltered;
  }
  filterOnAdmistrativeAreaLevel1(administrativeAreaLevel1, filteredByCountry) {
    let filteredVideos;
    if (administrativeAreaLevel1 === '') {
      filteredVideos = filteredByCountry
    }
    else {
      filteredVideos = this.filterOnLocality(administrativeAreaLevel1, filteredByCountry)
      if (filteredVideos.length === 0) {
        filteredVideos = filteredByCountry
      }
    }
    return filteredVideos;
  }
  OnClickClose() {
    let result = {
      windowHeader: this.data.windowHeader,
      isWindowClose: true
    }
    this.dialogRef.close(result);
  }
  onCLickOpenNewWindow() {
    let checkEmptyList = false
    if (this.videos.length === 0) {
      checkEmptyList = true
    }
    let result = {
      isWindowClose: checkEmptyList,
      videos: this.videos,
      country: this.selectedCountry,
      windowHeader: true,
    }
    this.dialogRef.close(result);
  }

  OnClickEmptyClose() {
    this.isEmptyResult = false;
    this.isNoResult = false;
    this.checkprime = false;
  }
  checkPrime() {
    this.isEmptyResult = false;
    this.isNoResult = false;
    if (!this.isPrime) {
      this.checkprime = true;
      return;
    } else {
      this.checkprime = false;
    }
  }
  toPaymentPage() {
    this.router.navigate(['/pricing']);
    setTimeout(() => {
      this.OnClickClose()
    }, 500);

  }
}